export default function (txt) {
  if (!txt) return
  const mtxt = txt.split('')
  let rtxt = ''
  mtxt.forEach((item) => {
    const a = item.toLowerCase()
    let b
    switch (a) {
      case 'а': b = 'a'; break
      case 'б': b = 'b'; break
      case 'в': b = 'v'; break
      case 'г': b = 'g'; break
      case 'д': b = 'd'; break
      case 'е': b = 'e'; break
      case 'ё': b = 'e'; break
      case 'ж': b = 'zh'; break
      case 'з': b = 'z'; break
      case 'и': b = 'i'; break
      case 'й': b = 'i'; break
      case 'к': b = 'k'; break
      case 'л': b = 'l'; break
      case 'м': b = 'm'; break
      case 'н': b = 'n'; break
      case 'о': b = 'o'; break
      case 'п': b = 'p'; break
      case 'р': b = 'r'; break
      case 'с': b = 's'; break
      case 'т': b = 't'; break
      case 'у': b = 'u'; break
      case 'ф': b = 'f'; break
      case 'х': b = 'kh'; break
      case 'ц': b = 'tc'; break
      case 'ч': b = 'ch'; break
      case 'ш': b = 'sh'; break
      case 'щ': b = 'shch'; break
      case 'ь': b = ''; break
      case 'ы': b = 'y'; break
      case 'ъ': b = ''; break
      case 'э': b = 'e'; break
      case 'ю': b = 'iu'; break
      case 'я': b = 'ia'; break
      default: b = a
    }
    rtxt += a === item ? b : b.toUpperCase()
  })
  return rtxt
}
